
import u from "umbrellajs"


const CELL_CLASS_NAME = "cell--app--real-estate-agencies--featured-agency-banners--one-banner"

class Cell {
  private element: HTMLElement
  private $element: UmbrellaInstance

  constructor(element: HTMLElement) {
    this.element = element
    this.$element = u(element)
  }

  public getBannerRecordId() {
    return this.$element.data("banner-record-id")
  }

  // On any mouse click, so we use "mousedown" event instead of "click"
  public onClick(callback_func: ({event, cell}: {event: Event, cell: Cell}) => any) {
    const self = this

    return this.$element.on("mousedown", (event) => {
      callback_func({
        event,
        cell: self,
      })
    })
  }
}

const OneBanner_Cell = {
  new(element: HTMLElement) {
    if (!element.classList.contains(CELL_CLASS_NAME)) {
      throw new Error("not supported element detected!")
    }

    return new Cell(element)
  },

  getCurrentCellsIn(parent_element: string | HTMLElement | UmbrellaInstance) {
    const self = this
    const cells = [] as Cell[]

    u(parent_element).find(`.${CELL_CLASS_NAME}`).each((el) => {
      cells.push(self.new(el))
    })

    return cells
  },
}


export default OneBanner_Cell
